import { Loader } from 'src/components/ui'
import { useGetUserQuery } from 'src/redux/api'
import MainLayout from '../main/MainLayout'
import PublicLayout from '../public/PublicLayout'

// Routes that exist for both audiences (the map/search storefront, 404) render
// the full authenticated shell for logged-in users and the lightweight public
// chrome for guests. Both layouts render an <Outlet/>, which resolves against
// the route this component is mounted on.
const AdaptiveLayout = () => {
  const { data: user, isLoading } = useGetUserQuery(undefined)

  if (isLoading) return <Loader />

  return user && !user.notRegistered ? <MainLayout /> : <PublicLayout />
}

export default AdaptiveLayout
